import { getData } from 'conversations-async-data/async-data/operators/getters';
import { getEmail, getVid, getJobTitle, getCompany, getAssociatedCompanyId, getAssociatedCompanyName } from 'conversations-inbox-lib/contacts/public/operators';
import { useContact } from '../../../crm-integration/hooks/useContact';
import { isKnownContact as isKnownContactOperator } from '../../../contacts/operators/isKnownContact';
import ContactAvatar from 'svh-workspace-ui-lib/ticket-header/public/ContactAvatar';
import UIBox from 'UIComponents/layout/UIBox';
import DetailHeaderWrapper from '../../../unified-inbox/components/DetailHeaderWrapper';
import { isLoading } from 'conversations-async-data/async-data/operators/statusComparators';
// @ts-expect-error type not available yet
import ThreadToolbarPlaceholder from 'conversations-thread-view/thread-toolbar/components/ThreadToolbarPlaceholder';
import ContactDetail from './ContactDetail';
import CompanyDetails from './CompanyDetails';
import { ConversationDetails } from 'svh-workspace-ui-lib/detail-header/public/components';
import UIFlex from 'UIComponents/layout/UIFlex';
import styled from 'styled-components';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import { useThreadMetaData } from 'conversations-inbox-lib/detail-header/public/hooks';
import { getMatchedCompanyLink, getContactDetail } from 'svh-workspace-ui-lib/detail-header/public/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUIFlex = styled(UIFlex).withConfig({
  displayName: "ThreadHeader__StyledUIFlex",
  componentId: "sc-113xlbh-0"
})(["font-size:14px;padding-top:3px;"]);
const StyledUIBox = styled(UIBox).withConfig({
  displayName: "ThreadHeader__StyledUIBox",
  componentId: "sc-113xlbh-1"
})(["height:18px;padding-top:3px;"]);
const SeparatorStyleWrapper = styled.span.withConfig({
  displayName: "ThreadHeader__SeparatorStyleWrapper",
  componentId: "sc-113xlbh-2"
})(["margin:0 8px;"]);
const ThreadHeader = ({
  threadId,
  children
}) => {
  const {
    asyncContact
  } = useContact({
    threadId
  });
  const {
    startedAt,
    closedAt,
    loading: threadLoading
  } = useThreadMetaData({
    threadId
  });
  const contact = getData(asyncContact);
  const vid = getVid(contact);
  const contactEmail = getEmail(contact) || '';
  const jobTitle = getJobTitle(contact) || '';
  const isKnownContact = isKnownContactOperator(contact);
  const loadingThreadHeader = isLoading(asyncContact);
  const associatedCompanyId = getAssociatedCompanyId(contact) || '';
  const associatedCompanyName = getAssociatedCompanyName(contact) || '';
  const company = getCompany(contact) || '';
  const companyLink = getMatchedCompanyLink({
    associatedCompanyId,
    associatedCompanyName,
    company
  });
  const contactDetail = getContactDetail(contact);
  if (loadingThreadHeader || threadLoading) {
    // TODO: We probably need a new loading state to match with the new header design
    return /*#__PURE__*/_jsx(ThreadToolbarPlaceholder, {});
  }
  return /*#__PURE__*/_jsxs(DetailHeaderWrapper, {
    className: "display-flex p-x-4 p-y-2",
    children: [/*#__PURE__*/_jsx(UIBox, {
      className: "m-right-3 m-y-1",
      children: /*#__PURE__*/_jsx(ContactAvatar, {
        isKnownContact: isKnownContact,
        email: contactEmail,
        contactDetail: contactDetail,
        vid: vid,
        threadId: threadId
      })
    }), /*#__PURE__*/_jsx(UIBox, {
      basis: 700,
      grow: 1,
      children: /*#__PURE__*/_jsxs(UIMediaObject, {
        className: "flex-column",
        children: [/*#__PURE__*/_jsx(StyledUIBox, {
          shrink: 1,
          children: /*#__PURE__*/_jsx(ContactDetail, {
            contactDetail: contactDetail,
            isKnownContact: isKnownContact
          })
        }), /*#__PURE__*/_jsxs(StyledUIFlex, {
          children: [/*#__PURE__*/_jsx(CompanyDetails, {
            associatedCompanyId: associatedCompanyId,
            jobTitle: jobTitle,
            company: company || associatedCompanyName,
            companyLink: companyLink,
            isKnownContact: isKnownContact,
            threadId: threadId
          }), startedAt && /*#__PURE__*/_jsxs(UIBox, {
            shrink: 0,
            children: [(company || jobTitle || !isKnownContact) && /*#__PURE__*/_jsx(SeparatorStyleWrapper, {
              children: '•'
            }), /*#__PURE__*/_jsx(ConversationDetails, {
              startedAt: startedAt,
              closedAt: closedAt
            })]
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(UIBox, {
      shrink: 0,
      className: "align-center justify-end p-y-2",
      children: children
    })]
  });
};
ThreadHeader.displayName = 'ThreadHeader';
export default ThreadHeader;